import React, { useState } from "react";
import { useSelector } from "react-redux";
import folderIcon from "../../images/icon/folder_icon.svg";
import starIcon from "../../images/icon/star_icon.svg";
import deleteIcon from "../../images/icon/delete_icon.svg";
import moreIcon from "../../images/icon/more_icon.svg";
import chatIcon from "../../images/icon/chat_icon.svg";
import shareIcon from "../../images/icon/share_icon.svg";
import serLeftIcon from "../../images/icon/ser_left_icon.svg";
import serRightIcon from "../../images/icon/ser_right_icon.svg";
import activeStartIcon from "../../images/icon/active_star_icon.svg";
import editIcon from "../../images/icon/edit_icon.svg";
import dropIcon from "../../images/icon/dropdown_icon.svg";
import checkIcon from "../../images/icon/check_icon.svg";

const LeftSection = ({
  userList,
  selectedProfile,
  setSelectedProfile,
  deleteHandler,
  searchHandler,
  starHandler,
  expandedHandler,
  addChildHandler,
  googleLogin,
  isMobile,
  logoutHandler,
  setIsCreatedNewChat,
}) => {
  const { loggedIn } = useSelector((state) => state.auth);
  const [isNewFolderShow, setIsNewFolderShow] = useState(false);
  const [addFolder, setAddFolder] = useState("");
  return (
    <div
      className={`backdrop-blur-lg bg-[#2d293b82] h-full w-full sm:w-full md:w-4/12 lg:w-1/5 flex flex-col justify-between gap-4 ${
        isMobile ? "rounded-none" : "rounded-r-[26px]"
      } py-8`}
    >
      <div
        className={
          "px-4 py-2 text-white flex flex-row items-center gap-4 w-full justify-between"
        }
      >
        <a href="/app">
          <div className={"flex flex-row items-center gap-4"}>
            <img src="/logo300.svg" alt={"logo"} className={"w-[40px]"} />
            <span className={"font-semibold text-2xl"}>FoxAcid</span>
          </div>
        </a>
        {isMobile &&
          (!loggedIn ? (
            <div
              className={
                "p-2 bg-transparent hover:bg-[#2313155e] border border-[#8C8A94] rounded-lg font-semibold text-base flex flex-row items-center gap-2 cursor-pointer"
              }
              onClick={googleLogin}
            >
              Login
            </div>
          ) : (
            <div
              className={
                "p-2 bg-transparent hover:bg-[#2313155e] border border-[#8C8A94] rounded-lg font-semibold text-base flex flex-row items-center gap-2 cursor-pointer"
              }
              onClick={logoutHandler}
            >
              Logout
            </div>
          ))}
      </div>
      <div className={"px-4 py-2 flex flex-row items-center gap-4"}>
        <div className={"w-full relative flex flex-col"}>
          <img
            src={serLeftIcon}
            alt={"serLeftIcon"}
            className={"w-[20px] cursor-pointer absolute left-[5px] top-[8px]"}
          />
          <input
            type={"text"}
            placeholder={"Search message.."}
            className={
              "p-2 px-8 rounded-[8px] border-0 w-full text-white font-semibold placeholder-[#8C8A94] outline-0 bg-[#2d293b]"
            }
            onChange={(e) => searchHandler(e.target.value)}
          />
          <img
            src={serRightIcon}
            alt={"serRightIcon"}
            className={"w-[20px] cursor-pointer absolute right-[5px] top-[8px]"}
          />
        </div>
        <img
          src={folderIcon}
          alt={"folderIcon"}
          className={"w-[20px] cursor-pointer"}
          onClick={() => setIsNewFolderShow(true)}
        />
      </div>
      <div
        className={
          "h-full flex flex-col overflow-auto w-full no-scrollbar bg-transparent"
        }
      >
        {isNewFolderShow && (
          <div
            className={
              "px-4 py-2 flex flex-row gap-2 items-center border-b border-[#8C8A94]"
            }
          >
            <img
              src={dropIcon}
              alt={"dropIcon"}
              className={"w-[30px] cursor-pointer"}
            />
            <input
              className={
                "bg-transparent border border-[#8C8A94] rounded-[8px] p-[6px] w-full text-white outline-0"
              }
              placeholder={"Name your folder..."}
              value={addFolder}
              onChange={(e) => setAddFolder(e.target.value)}
            />
            <div className={"flex flex-row"}>
              <img
                src={checkIcon}
                alt={"checkIcon"}
                className={"w-[30px] cursor-pointer"}
                onClick={() => {
                  setIsNewFolderShow(false);
                  addChildHandler(addFolder);
                  setAddFolder("");
                }}
              />
              <img
                src={deleteIcon}
                alt={"deleteIcon"}
                className={"w-[30px] cursor-pointer"}
                onClick={() => {
                  setIsNewFolderShow(false);
                  setAddFolder("");
                }}
              />
            </div>
          </div>
        )}
        {userList?.map((item, index) => {
          const startIcons = item.startActive ? activeStartIcon : starIcon;
          return (
            <div key={`user_${index}`} className={`flex flex-col`}>
              {item?.children?.length > 0 ? (
                <div className={"flex flex-col"}>
                  <div
                    className={`flex w-full flex-row items-center border-b border-[#8C8A94] justify-between px-4 py-2 gap-2 text-white cursor-pointer group ${
                      item.id === selectedProfile?.id
                        ? "bg-buttonPrimary"
                        : "bg-transparent hover:bg-[#00000052]"
                    }`}
                  >
                    <div
                      className={
                        "flex flex-row gap-2 truncate h-[45px] items-center group-hover:w-20"
                      }
                    >
                      <img
                        src={dropIcon}
                        alt={"dropIcon"}
                        className={`w-[20px] cursor-pointer ${
                          item?.isExpanded ? "rotate-180" : "rotate-0"
                        }`}
                        onClick={() => expandedHandler(item?.id)}
                      />
                      <span className={"truncate"}>{item.title}</span>
                    </div>
                    <div className={"hidden group-hover:flex flex-row gap-1"}>
                      <img
                        src={editIcon}
                        alt={"editIcon"}
                        className={"w-[20px] cursor-pointer"}
                      />
                      <img
                        src={startIcons}
                        alt={"starIcon"}
                        className={"w-[20px] cursor-pointer"}
                        onClick={() => starHandler(false, item.id)}
                      />
                      <img
                        src={deleteIcon}
                        alt={"deleteIcon"}
                        className={"w-[20px] cursor-pointer"}
                        onClick={() => deleteHandler(false, item?.id)}
                      />
                      <img
                        src={shareIcon}
                        alt={"shareIcon"}
                        className={"w-[20px] cursor-pointer"}
                      />
                      <img
                        src={moreIcon}
                        alt={"moreIcon"}
                        className={"w-[20px] cursor-pointer"}
                      />
                    </div>
                  </div>
                  {item?.isExpanded &&
                    item?.children?.map((data) => {
                      const startIconsChild = data.startActive
                        ? activeStartIcon
                        : starIcon;
                      return (
                        <>
                          <div
                            className={`flex flex-row items-center border-b border-[#8C8A94] justify-between pl-9 pr-4 py-2 gap-2 text-white cursor-pointer group ${
                              data.id === selectedProfile?.id
                                ? "bg-buttonPrimary"
                                : "bg-transparent hover:bg-[#00000052]"
                            }`}
                            key={data.id}
                          >
                            <div
                              className={"flex flex-row gap-2 w-full"}
                              onClick={() => {
                                setSelectedProfile({
                                  ...data,
                                });
                                setIsCreatedNewChat(false);
                              }}
                            >
                              <img
                                src={data.profileUrl}
                                alt={"logo"}
                                className={"w-[40px] h-[40px] rounded-full"}
                              />
                              <div
                                className={
                                  "flex flex-col truncate group-hover:w-16"
                                }
                              >
                                <span
                                  className={"font-semibold text-base truncate"}
                                >
                                  {data.title}
                                </span>
                                <span
                                  className={`font-semibold text-sm truncate ${
                                    data.id === selectedProfile?.id
                                      ? "text-white"
                                      : "text-[#8C8A94]"
                                  }`}
                                >
                                  {data.description}
                                </span>
                              </div>
                            </div>
                            <div
                              className={
                                "hidden group-hover:flex flex-row gap-1 w-[170px]"
                              }
                            >
                              <img
                                src={editIcon}
                                alt={"editIcon"}
                                className={"w-[20px] cursor-pointer"}
                              />
                              <img
                                src={startIconsChild}
                                alt={"starIcon"}
                                className={"w-[20px] cursor-pointer"}
                                onClick={() =>
                                  starHandler(true, item.id, data.id)
                                }
                              />
                              <img
                                src={deleteIcon}
                                alt={"deleteIcon"}
                                className={"w-[20px] cursor-pointer"}
                                onClick={() =>
                                  deleteHandler(true, item?.id, data.id)
                                }
                              />
                              <img
                                src={shareIcon}
                                alt={"shareIcon"}
                                className={"w-[20px] cursor-pointer"}
                              />
                              <img
                                src={moreIcon}
                                alt={"moreIcon"}
                                className={"w-[20px] cursor-pointer"}
                              />
                            </div>
                          </div>
                        </>
                      );
                    })}
                </div>
              ) : (
                <div
                  className={`flex flex-row w-full border-b items-center justify-between px-4 py-2 gap-2 text-white cursor-pointer group ${
                    item.id === selectedProfile?.id
                      ? "bg-buttonPrimary border-transparent"
                      : "bg-transparent hover:bg-[#00000052] border-[#8C8A94]"
                  }`}
                  key={item.id}
                >
                  <div
                    className={"flex flex-row gap-2 w-full"}
                    onClick={() => {
                      setSelectedProfile({
                        ...item,
                      });
                      setIsCreatedNewChat(false);
                    }}
                  >
                    <img
                      src={item.profileUrl}
                      alt={"logo"}
                      className={"w-[40px] h-[40px] rounded-full"}
                    />
                    <div className={"flex flex-col truncate group-hover:w-20"}>
                      <span className={"font-semibold text-base truncate"}>
                        {item.title}
                      </span>
                      <span
                        className={`font-semibold text-sm truncate ${
                          item.id === selectedProfile?.id
                            ? "text-white"
                            : "text-[#8C8A94]"
                        }`}
                      >
                        {item.description}
                      </span>
                    </div>
                  </div>
                  <div
                    className={
                      "hidden group-hover:flex flex-row gap-1 w-[170px]"
                    }
                  >
                    <img
                      src={editIcon}
                      alt={"editIcon"}
                      className={"w-[20px] cursor-pointer"}
                    />
                    <img
                      src={startIcons}
                      alt={"starIcon"}
                      className={"w-[20px] cursor-pointer"}
                      onClick={() => starHandler(false, item.id)}
                    />
                    <img
                      src={deleteIcon}
                      alt={"deleteIcon"}
                      className={"w-[20px] cursor-pointer"}
                      onClick={() => deleteHandler(false, item?.id)}
                    />
                    <img
                      src={shareIcon}
                      alt={"shareIcon"}
                      className={"w-[20px] cursor-pointer"}
                    />
                    <img
                      src={moreIcon}
                      alt={"moreIcon"}
                      className={"w-[20px] cursor-pointer"}
                    />
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className={"px-4 py-2"}>
        <button
          className={
            "flex flex-row gap-2 justify-center w-full items-center bg-buttonPrimary text-white text-base font-semibold p-2 rounded-[8px]"
          }
          onClick={() => {
            setIsCreatedNewChat(true);
            setSelectedProfile(null);
          }}
        >
          <img src={chatIcon} alt={"chat icon"} />
          Create New Chat
        </button>
      </div>
    </div>
  );
};
export default LeftSection;
